import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useState } from "react";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import {SelectChangeEvent,} from "@mui/material";
import CustomSelect from "@/shared/components/common/select";
import {numberSeparator,toPersianNumber,} from "@/hooks/useThousandsSeparator";
import moment from "jalali-moment";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
/**
 * Transactions
 *
 * نمایش لیست تراکنش‌های کیف پول کاربر.
 *
 * - دریافت داده‌ها از props `data`.
 * - نمایش تاریخ تراکنش به فرمت شمسی با استفاده از moment-jalali.
 * - نمایش وضعیت تراکنش (موفق، در انتظار پرداخت، ناموفق) با آیکون رنگی.
 * - نمایش مبلغ تراکنش با جداکننده هزارگان و واحد ریال.
 * - امکان انتخاب تعداد تراکنش‌های نمایش داده شده از طریق CustomSelect.
 *
 * @param {Object} props
 * @param {any} props.data داده‌های تراکنش‌ها
 *
 * @returns JSX.Element
 */

const Transactions = ({ data }: { data: any }) => {
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };

  return (
    <CardKit sx={{background:"linear-gradient(136.6deg, rgba(0, 0, 0, 0.47) -3.14%, rgba(79, 79, 79, 0.37) 48.83%, rgba(0, 0, 0, 0.4) 109.82%);",}}
      width={"100%"}
      height={468}
      title={
        <StackKit justifyContent={"space-between"} sx={{flexDirection: { md: "column", lg: "row !important" },}}>
          <StackKit direction={"row"} gap={1} alignItems={"center"}>
            <ReceiptLongOutlinedIcon style={{ color: "#fff" }} />
            <TypoGraphyKit>تراکنش شتابی</TypoGraphyKit>
          </StackKit>
          <CustomSelect
            label={
              <TypoGraphyKit variant="body1" sx={{ color: "#A4A4A4" }}>
                تراکنش آخر
              </TypoGraphyKit>
            } value={10} options={[10]} onChange={(val) => console.log("selected:", val)}
          />
        </StackKit>
      }
    >
      <StackKit sx={{width: "100%",justifyContent: "flex-start",alignItems: "center",maxHeight: "387px",overflow: "auto",}}>
        {data?.data?.transfers.map((item: any) => {
          const data = toPersianNumber(moment(item.created_at).locale("fa").format(" D MMMM "));
          const day = moment(item.created_at).locale("fa").format("dddd");

          return (
            <StackKit key={item.id} direction={"row"} justifyContent={"space-between"} sx={{ width: "100%", padding: "20px 10px" }} alignItems={"center"}>
              <StackKit justifyContent={"end"} alignItems={"start"} sx={{ position: "relative", width: "30%" }}>
                <TypoGraphyKit variant="body1">{data}</TypoGraphyKit>
                <TypoGraphyKit component={"span"} variant="body1" sx={{fontSize: "8px",position: "absolute",bottom: "-10px",}}>
                  {day}
                </TypoGraphyKit>
              </StackKit>
              <StackKit direction={"row"} sx={{ width: "30%", margin: "0 !important" }} alignItems={"center"} justifyContent={"space-between"}>
                {item.status === "success" || item.status === 1 ? (
                  <TypoGraphyKit variant="body1" sx={{ fontSize: "8px", color: "green" }}>
                    شارژ موفق
                  </TypoGraphyKit>
                  ) : (
                  <TypoGraphyKit variant="body1" sx={{ fontSize: "8px", color: "red" }}>
                    شارژ ناموفق
                  </TypoGraphyKit>
                )}
                {item.status === "success" || item.status === 1 ? (
                  <CheckCircleOutlineIcon style={{ color: "green" }} />
                ) : (
                  <CancelOutlinedIcon style={{ color: "red" }} />
                )}
              </StackKit>
              <StackKit direction={"row"} alignItems={"center"} sx={{width: { xs: "50%", sm: "45%", md: "40%" },margin: "0!important",}} justifyContent={"end"} gap={1} flexWrap={"wrap"}>
                <TypoGraphyKit variant="h6">
                  {numberSeparator(item.amount)}
                </TypoGraphyKit>
                <TypoGraphyKit variant="body1" sx={{ fontSize: "8px", margin: "0!important" }}>
                  ریال
                </TypoGraphyKit>
              </StackKit>
            </StackKit>
          );
        })}
      </StackKit>
    </CardKit>
  );
};

export default Transactions;
